export default __webpack_public_path__ + "static/media/004-A-telephonemobile.40375874.svg";